import React from 'react';
import { RiAddLine, RiRefreshLine, RiFileDownloadLine } from 'react-icons/ri';

interface ActionButtonsRowProps {
  onAdd?: () => void;
  addLabel?: string;
  addIcon?: React.ReactNode;
  onRefresh?: () => void;
  refreshLabel?: string;
  // FINDING-S470-001 FIX: signal in-flight state so refresh button can disable + aria-busy
  refreshLoading?: boolean;
  onExport?: () => void;
  exportLabel?: string;
  exportDisabled?: boolean;
  showAdd?: boolean;
  showRefresh?: boolean;
  showExport?: boolean;
  customButtons?: React.ReactNode;
  className?: string;
}

const ActionButtonsRow: React.FC<ActionButtonsRowProps> = ({
  onAdd,
  addLabel = 'เพิ่มข้อมูล',
  addIcon,
  onRefresh,
  refreshLabel = 'รีเฟรช',
  refreshLoading = false,
  onExport,
  exportLabel = 'ส่งออก Excel',
  exportDisabled = false,
  showAdd = true,
  showRefresh = true,
  showExport = true,
  customButtons,
  className = '',
}) => {
  return (
    <div className={`flex flex-wrap items-center gap-2 mb-4 ${className}`}>
      {showAdd && onAdd && (
        <button
          onClick={onAdd}
          className="group inline-flex items-center px-4 min-h-[44px] sm:min-h-[42px] py-2.5 bg-primary-600 text-white text-sm font-medium rounded-lg shadow-button hover:bg-primary-700 hover:shadow-button-hover focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 transition-all duration-200"
        >
          {addIcon || <RiAddLine className="w-5 h-5 mr-1 group-hover:rotate-90 transition-transform duration-300" />}
          {addLabel}
        </button>
      )}
      {showExport && onExport && (
        <button
          onClick={onExport}
          disabled={exportDisabled}
          className="inline-flex items-center px-4 min-h-[44px] sm:min-h-[42px] py-2.5 bg-white border border-secondary-300 text-secondary-700 text-sm font-medium rounded-lg shadow-button hover:bg-secondary-50 hover:border-secondary-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
        >
          <RiFileDownloadLine className="w-5 h-5 mr-1" />
          {exportLabel}
        </button>
      )}
      {customButtons}
      {showRefresh && onRefresh && (
        <button
          onClick={onRefresh}
          disabled={refreshLoading}
          aria-busy={refreshLoading}
          className="group inline-flex items-center px-4 min-h-[44px] sm:min-h-[42px] py-2.5 bg-white border border-secondary-300 text-secondary-700 text-sm font-medium rounded-lg shadow-button hover:bg-secondary-50 hover:border-secondary-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
        >
          <RiRefreshLine className={`w-5 h-5 mr-1 transition-transform duration-500 ${refreshLoading ? 'animate-spin' : 'group-hover:rotate-180'}`} />
          {refreshLoading ? 'กำลังโหลด...' : refreshLabel}
        </button>
      )}
    </div>
  );
};

export default ActionButtonsRow;
